import styled from 'styled-components';

const getVariantColours = ({ variant = 'tan', theme } = {}) => {
  const variants = {
    tan: {
      background: theme.colours.tan,
      text: theme.colours.red,
    },
    yellow: {
      background: theme.colours.yellow,
      text: theme.colours.red,
    },
    brown: {
      background: theme.colours.brown,
      text: theme.colours.yellow,
    },
    blue: {
      background: theme.colours.blue,
      text: theme.colours.yellow,
    },
    darkbrown: {
      background: '#592A03',
      text: theme.colours.yellow,
    },
  };

  if (variant in variants) return variants[variant];
  return variants.tan;
};

const ImageSliderWrapper = styled.section`
  width: 100%;
  position: relative;
  padding-top: 20px;
  overflow: hidden;
  background-color: ${({ backgroundColor, backgroundHex, theme }) =>
    backgroundHex
      ? backgroundHex // use raw hex if provided
      : getVariantColours({ theme, variant: backgroundColor }).background};
  .imageSlider-inner{
    width: 1200px;
    max-width: 90%;
    margin: auto;
    position: relative;
    .corner-graphic{
      position: absolute;
      top: -60px;
      right: -70px;
    }
    .title-text{
      display: block;
      text-align: center;
    }
  }
  .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slick-dots {
    bottom: 10px;
  }
  @media (max-width: 900px){
    padding-top: 60px;
    .imageSlider-inner .corner-graphic{
      top: -100px;
      right: -100px;
    }
  }
`;

export const CarouselControls = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    top: 37%;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    width: 1500px;
    max-width: 95%;
    margin: auto;
    button{
      border: 2px solid #fff !important;
    }
    .prev{
        position: absolute;
        left: 0;
    }
    .next{
      position: absolute;
      right: 0;
    }
    @media (max-width: 980px){
        display: none;
    }
`;

export const PlaceholderWrapper = styled.div`
  position: relative;
`;

export default ImageSliderWrapper;